





































































































































import { ConsultoresService } from "@/services/consultores.service";
import { HomeService } from "@/services/home.service";
import { ToastService } from "@/services/toast.service";
import DataTable from "@/shared/components/data-table.vue";
import Modal from "@/shared/components/modal.vue";
import { dateTimeSeconds, moeda } from "@/shared/filters";
import { Component, Vue } from "vue-property-decorator";
import CancelarTransacao from "./CancelarTransacao.vue";
import ProcessarTransacaoPagseguro from "./ProcessarTransacaoPagseguro.vue";

@Component({
  components: {
    DataTable,
    Modal,
    CancelarTransacao,
    ProcessarTransacaoPagseguro,
  },
  filters: { moeda, dateTimeSeconds },
})
export default class DetalhesPlano extends Vue {
  plano: any = null;
  idPlano: number | null = null;
  idTransacao: number | null = null;
  nomePlano: string | null = null;
  promiseStatus: Promise<any[]> | null = null;
  transacoes: any[] = [];
  loading = false;
  ambiente: string | null = null;

  headersStatus = [
    { value: "data", text: "Data" },
    { value: "status", text: "Status" },
    { value: "observacao", text: "Observação" },
  ];

  get tituloManter(): string {
    return "Detalhes do plano";
  }

  rotuloDoIdentificador(transacao: any): string {
    if (transacao.tipoMeioPagamento === "CIELO") return "TID";
    if (transacao.tipoMeioPagamento === "INTER") return "ID Transação";
    return "Identificador";
  }

  async copiar(valor: string) {
    await navigator.clipboard.writeText(valor);

    ToastService.open({
      message: "Copiado.",
      type: "success",
      duration: 2000,
      position: "bottom-end",
    });
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async detalhesPlano(idPlano: number) {
    const modal = this.$refs.modal as Modal;
    modal.open();
    this.loading = true;
    this.idPlano = idPlano;
    let dadosPlano;
    try {
      dadosPlano = await ConsultoresService.StatusPlano(idPlano);
    } catch {
      this.loading = false;
    }
    this.loading = false;
    if (dadosPlano) {
      this.promiseStatus = dadosPlano.planos;
      this.transacoes = dadosPlano.transacoes || [];
      this.nomePlano = dadosPlano.nomePlano;
    }
  }

  mounted() {
    HomeService.Ambiente().then((ambiente) => {
      this.ambiente = ambiente;
    });
  }

  async cancelar(item: any) {
    const modal = this.$refs.cancelarTransacao as CancelarTransacao;
    await modal.cancelamentoTransacao(item);
    this.detalhesPlano(this.idPlano!);
  }

  async simularPagamento(item: any) {
    this.idTransacao = item.idTransacao;
    this.loading = true;
    await ConsultoresService.SimularPagamentoInter(item.idTransacao).finally(() => this.loading = false);

    ToastService.open({
      message: "Simulação de pagamento realizada com sucesso. Aguarde o processamento do pagamento que irá ocorrer em breve.",
      type: "success",
      duration: 5000,
      position: "bottom-end",
    })

    this.detalhesPlano(this.idPlano!);
  }

  async processarTransacaoPagseguro(item: any) {
    const modal = this.$refs
      .processarTransacaoPagseguro as ProcessarTransacaoPagseguro;
    await modal.statusTransacao(item.codigo);
    this.detalhesPlano(this.idPlano!);
  }

  setStatusPlano(status: number) {
    switch (status) {
      case 0:
        return "Cadastrado";
      case 1:
        return "Aguardando Pagamento";
      case 2:
        return "Ativo";
      case 3:
        return "Expirado";
      case 4:
        return "Contratado";
      case 9:
        return "Cancelado";
    }
  }
}
